import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export interface IListingData {
  pagedItems: [];
  pageSize: number;
  pageNumber: number;
  totalCount: number;
}

export const getHeaders = (
  currency?: string
): Record<string, EnhancedTableHeader> => ({
  Production_Policy_CertificateNumber: {
    name: 'Production_Policy_CertificateNumber',
    title: 'Certificate Number',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/policies/{policyId}',
    openUrlInNewTab: false,
  },
  Production_Policy_SublineID: {
    name: 'Production_Policy_SublineID',
    title: 'Subline',
    type: EnhancedTableHeaderType.Text,
  },
  Production_Policy_PlanID: {
    name: 'Production_Policy_PlanID',
    title: 'Plan',
    type: EnhancedTableHeaderType.Text,
  },
  PolicyMedical_Class: {
    name: 'PolicyMedical_Class',
    title: 'Class',
    type: EnhancedTableHeaderType.Text,
  },
  PolicyPerson_FullName: {
    name: 'PolicyPerson_FullName',
    title: 'Insured',
    type: EnhancedTableHeaderType.Text,
  },
  PolicyPerson_DateOfBirth: {
    name: 'PolicyPerson_DateOfBirth',
    title: 'Age',
    type: EnhancedTableHeaderType.Text,
  },
  PricingOption_SumInsured: {
    name: 'PricingOption_SumInsured',
    title: 'Sum Insured',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PricingOption_NetPremium: {
    name: 'PricingOption_NetPremium',
    title: 'Net Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PricingOption_PolicyCostAmount: {
    name: 'PricingOption_PolicyCostAmount',
    title: 'Cost & Charges',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PricingOption_FixedStampAmount: {
    name: 'PricingOption_FixedStampAmount',
    title: 'Taxes',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PricingOption_TotalPremium: {
    name: 'PricingOption_TotalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  Production_Policy_PolicyEffectiveDate: {
    name: 'Production_Policy_PolicyEffectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date,
  },
  Production_Policy_Status: {
    name: 'Production_Policy_Status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
});

export const excelHeaders = (currencySymbol?: string) => ({
  certificateNumber: {
    label: 'Certificate Number',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
  subline: {
    label: 'Subline',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
  plan: {
    label: 'Plan',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
  policyClass: {
    label: 'Class',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
  insuredName: {
    label: 'Insured',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
  insuredAge: {
    label: 'Age',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
  sumInsured: {
    label: `Sum Insured - ${currencySymbol}`,
    visible: true,
    isDate: false,
    isCurrency: true,
    currencySymbol,
  },
  netPremium: {
    label: `Net Premium - ${currencySymbol}`,
    visible: true,
    isDate: false,
    isCurrency: true,
    currencySymbol,
  },
  costAndCharges: {
    label: `Cost & Charges - ${currencySymbol}`,
    visible: true,
    isDate: false,
    isCurrency: true,
    currencySymbol,
  },
  taxes: {
    label: `Taxes - ${currencySymbol}`,
    visible: true,
    isDate: false,
    isCurrency: true,
    currencySymbol,
  },
  totalPremium: {
    label: `Total Premium - ${currencySymbol}`,
    visible: true,
    isDate: false,
    isCurrency: true,
    currencySymbol,
  },
  effectiveDate: {
    label: 'Effective Date',
    visible: true,
    isDate: true,
    isCurrency: false,
    currencySymbol,
  },
  status: {
    label: 'Status',
    visible: true,
    isDate: false,
    isCurrency: false,
    currencySymbol,
  },
});

export const summaryPopupHeaders: Record<string, EnhancedTableHeader> = {
  subline: {
    name: 'subline',
    title: 'Subline',
    type: EnhancedTableHeaderType.Text,
  },
  plan: {
    name: 'plan',
    title: 'Plan',
    type: EnhancedTableHeaderType.Text,
  },
  policyClass: {
    name: 'policyClass',
    title: 'Class',
    type: EnhancedTableHeaderType.Text,
  },
  insuredName: {
    name: 'insuredName',
    title: 'Insured',
    type: EnhancedTableHeaderType.Text,
  },
  insuredAge: {
    name: 'insuredAge',
    title: 'Age',
    type: EnhancedTableHeaderType.Text,
  },
  sumInsured: {
    name: 'sumInsured',
    title: 'Sum Insured',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  netPremium: {
    name: 'netPremium',
    title: 'Net Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  costAndCharges: {
    name: 'costAndCharges',
    title: 'Cost & Charges',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  taxes: {
    name: 'taxes',
    title: 'Taxes',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  totalPremium: {
    name: 'totalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  effectiveDate: {
    name: 'effectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date,
  },
  // status: {
  //   name: 'status',
  //   title: 'Status',
  //   type: EnhancedTableHeaderType.Text,
  // },
};
